import { cn } from 'lib/helpers/utility';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

const statusColors = {
  completed: 'success',
  pending: 'warning',
  cancelled: 'danger'
};

const TransactionStatus = ({ status }) => {
  const color = statusColors[status] || 'neutral';

  if (!status) return null;

  return (
    <div
      className={cn(
        'flex h-5 w-fit items-center justify-center gap-1 rounded-full border border-solid border-[rgba(0,0,0,0.12)] px-2 py-0',
        `bg-${color}-100`
      )}>
      <Dot color={color} />
      <Typography variant="label" size="small" weight="medium">
        {status}
      </Typography>
    </div>
  );
};

export default TransactionStatus;
